import { delay, HttpResponse } from "msw";

export const postToken = async () => {
  await delay("real");
  return HttpResponse.json({
    access_token: "string",
    refresh_token: "string",
    expires_in: 0,
  });
};
